<section
  id="overview"
  class="row center overview__container"
  *ngIf="isLoggedIn() && companyService.selectedCompany">
  <div class="container col-12 col-lg-6">
    <mat-card
      appearance="outlined"
      class="overview-card">
      <mat-card-header>
        <mat-card-title
          >{{ localizationConstants.OVERVIEW_MY_TOOLS | translate }} (<span [id]="toolsTotalId">{{
            toolsTotal
          }}</span
          >)</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div>
          <ul class="overview-card__list">
            <li
              *ngFor="let item of toolStatusItems; trackBy: trackByFn"
              (click)="onOverviewLinkClick(item)"
              class="overview-card__item">
              <a class="overview-card__link"
                >{{ item.title | translate }}
                <span
                  class="overview-card__count"
                  [class.highlight-count]="item.highlightCount && item.count > 0"
                  [id]="item.type"
                  >{{ item.count }}</span
                >
                <mat-icon
                  svgIcon="chevronRight"
                  class="overview-card__icon"></mat-icon>
                <div class="lines-wrapper">
                  <div class="empty-line"></div>
                  <div
                    class="full-line"
                    [style.--line-width]="
                      (toolsTotal > 0 ? (item.count / toolsTotal) * 100 : 0) + '%'
                    "></div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="container u-flex-column gap-xl col-12 col-lg-6">
    <mat-card
      appearance="outlined"
      class="overview-card">
      <mat-card-header>
        <mat-card-title
          >{{ localizationConstants.OVERVIEW_SERVICE_WARNINGS | translate }} (<span
            [id]="warningsTotalId"
            >{{ warningsTotal }}</span
          >)</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div>
          <ul class="overview-card__list">
            <li
              *ngFor="let item of serviceWarningsItems; trackBy: trackByFn"
              (click)="onOverviewLinkClick(item)"
              class="overview-card__item">
              <a class="overview-card__link"
                >{{ item.title | translate }}
                <span
                  class="overview-card__count"
                  [class.highlight-count]="item.highlightCount && item.count > 0"
                  [id]="item.type"
                  >{{ item.count }}</span
                >
                <mat-icon
                  svgIcon="chevronRight"
                  class="overview-card__icon"></mat-icon>
                <div class="lines-wrapper">
                  <div class="empty-line"></div>
                  <div
                    class="full-line"
                    [style.--line-width]="
                      (warningsTotal > 0 ? (item.count / warningsTotal) * 100 : 0) + '%'
                    "></div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card
      *ngIf="isTechCoverVisible()"
      appearance="outlined"
      class="overview-card">
      <mat-card-header>
        <mat-card-title>{{
          localizationConstants.OVERVIEW_SOFTWARE_SUPPORT | translate
        }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div>
          <ul class="overview-card__list">
            <li class="overview-card__item">
              <a
                [routerLink]="[routeConstants.TECH_COVER]"
                class="overview-card__link"
                >{{ localizationConstants.OVERVIEW_TECH_COVER_ACTIVE_TICKETS | translate }}
                <span
                  class="overview-card__count"
                  [class.highlight-count]="supportTicketsCount > 0"
                  >{{ supportTicketsCount }}</span
                >
                <mat-icon
                  svgIcon="chevronRight"
                  class="overview-card__icon"></mat-icon>
                <div class="lines-wrapper">
                  <div class="empty-line"></div>
                  <div
                    class="full-line"
                    [style.--line-width]="supportTicketsLineWidth"></div>
                </div>
              </a>
            </li>
          </ul>
          <ul
            *ngIf="techCoverContact"
            class="contact-list">
            <li>
              <a
                class="contact-detail"
                [href]="'mailto:' + techCoverContact.email"
                target="_blank">
                <mat-icon
                  color="primary"
                  svgIcon="email"></mat-icon>
                <span>{{ techCoverContact.email }}</span>
              </a>
            </li>
            <li *ngIf="techCoverContact.phone">
              <a
                class="contact-detail"
                [href]="'tel:' + techCoverContact.phone">
                <mat-icon
                  color="primary"
                  svgIcon="phone"></mat-icon>
                <span>{{ techCoverContact.phone }}</span>
              </a>
            </li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</section>
